module.exports = {
          srcSet: __webpack_public_path__ + "160f51fc.jpg"+" 700w"+","+__webpack_public_path__ + "ed32f629.jpg"+" 1400w"+","+__webpack_public_path__ + "f0dfd56e.jpg"+" 2100w"+","+__webpack_public_path__ + "f1c33656.jpg"+" 2573w",
          images:[ {path: __webpack_public_path__ + "160f51fc.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "ed32f629.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "f0dfd56e.jpg",width: 2100,height: 1401},{path: __webpack_public_path__ + "f1c33656.jpg",width: 2573,height: 1716}],
          src: __webpack_public_path__ + "160f51fc.jpg",
          toString:function(){return __webpack_public_path__ + "160f51fc.jpg"},
          
          width: 700,
          height: 467
        }